__turbopack_context__.v({
  "buttonWrapper": "BlockTwoColumnTextAlt-module-scss-module__kIes_q__buttonWrapper",
  "column": "BlockTwoColumnTextAlt-module-scss-module__kIes_q__column",
  "flushBottom": "BlockTwoColumnTextAlt-module-scss-module__kIes_q__flushBottom",
  "flushTop": "BlockTwoColumnTextAlt-module-scss-module__kIes_q__flushTop",
  "headline": "BlockTwoColumnTextAlt-module-scss-module__kIes_q__headline",
  "icon": "BlockTwoColumnTextAlt-module-scss-module__kIes_q__icon",
  "iconWrapper": "BlockTwoColumnTextAlt-module-scss-module__kIes_q__iconWrapper",
  "inner": "BlockTwoColumnTextAlt-module-scss-module__kIes_q__inner",
  "line": "BlockTwoColumnTextAlt-module-scss-module__kIes_q__line",
  "makersReserve": "BlockTwoColumnTextAlt-module-scss-module__kIes_q__makersReserve",
  "richEyebrow": "BlockTwoColumnTextAlt-module-scss-module__kIes_q__richEyebrow",
  "root": "BlockTwoColumnTextAlt-module-scss-module__kIes_q__root",
  "ultrabold": "BlockTwoColumnTextAlt-module-scss-module__kIes_q__ultrabold",
});
